export default "__VITE_ASSET__BQlkXAQx__"